'use client';

import { StackProps, VStack } from '@chakra-ui/react';
import { useAppLayoutContext } from './AppLayoutContext';

export type MainViewProps = StackProps;

export const MainView = (props: MainViewProps) => {
  const { bg, ...rest } = props;

  const { variant } = useAppLayoutContext();

  return (
    <VStack
      gap={['1.5rem', '1.5rem', 0]}
      align={['center', 'center', 'flex-start']}
      justify="flex-start"
      w="full"
      pl={['auto', 'auto', '2.5rem']}
      mr="auto"
      mb={['1.5rem', '1.5rem', 0]}
      bg={
        variant === 'error' ? ['transparent', 'transparent', 'error.500'] : bg
      }
      {...rest}
    />
  );
};
